import React, { useState } from 'react';
import { FaAddressCard, FaUser, FaCheckCircle, FaFileAlt } from 'react-icons/fa'; // For Icons
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";


const StakeHolderDetails = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const steps = [
    { name: 'Partner/Director', icon: <FaAddressCard /> },
    { name: 'Identity', icon: <FaUser /> },
    { name: 'Attachments', icon: <FaFileAlt /> },
    
  ];
  const navigate = useNavigate();


  // Handle Next Button Click
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle Previous Button Click
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    console.log("Form submitted!");
    navigate("/bank-documents");
  };

  return (
    <div id="msform" className="container mt-4 ">
      {/* Progress Bar */}
      <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`text-center ${index <= currentStep ? 'active' : ''}`}
            id={step.name.toLowerCase().replace(' ', '')}
          >
            <div className="step-icon mb-1">{step.icon}</div>
            <span>{step.name}</span>
          </li>
        ))}
      </ul>


  {/* Partner/Director */}
     <Container className="mt-5" >
        <Form>
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 0 ? "block" : "none", // Ensure it's toggleable based on steps
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
              textAlign:"left"
            }}
           
          >
            <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              Partner/Director
            </h6>
            <hr
              style={{
                margin:"5px",
                border: "1px solid #748292",
                width: "100%",
              }}
            />

           
            <div className="row mb-3" >
              <label className="col-md-3 col-form-label text-start ">Given Name *</label>
              <div className="col-md-9" >
                <input
                
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your full legal name"
                  required
                />
              </div>
            </div>

            {/* Other Name */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start "> Family Name</label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter any other name"
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Role as a Director
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Executive Director</option>
                  <option>Non-Executive Director</option>
                  <option>Independent Director</option>
                  <option>Other</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
               Position in the Company
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>CEO</option>
                  <option>Dy. CEO</option>
                  <option>Independent Director</option>
                  <option>COO</option>
                  <option>Dy. COO</option>
                  <option>Asst./Dy. GM</option>
                  <option>President</option>
                  <option>Vice President</option>
                  <option>Asst. Vice President</option>
                  <option>Manager</option>
                  <option>Head</option>
                  <option>Dy. /Asst. Manager</option>
                  <option>Sr. Executive</option>
                  <option>None</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Authorised Signatory
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Type of Signing Authority
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Single/Sole</option>
                  <option>Joint</option>
                  <option>Limited</option>
                </select>
              </div>
            </div>

            {/* PEP Name */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                PEP Name 
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter place of birth"
                  required
                />
              </div>
            </div>

            {/* Nationality */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Position Held
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your nationality"
                  required
                />
              </div>
            </div>

            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Name of PEP Relative/Associate
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your passport number"
                />
              </div>
            </div>

            

           
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Relationship with PEP Name
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter place of issue"
                />
              </div>
            </div>
            </fieldset>

          </Form>    

       {/* Identity */}
        <fieldset
          style={{
           textAlign:"left",
           display: currentStep === 1 ? "block" : "none"}}
           >
           
          <div  style={{
            margin: "10px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 0px 20px #748292",
            transition: "all 0.5s ease-in-out"}} >
              <h6 className="text-start " style={{ marginBottom: "0.7rem" }}>Identity</h6>
              <hr  style={{
                border: "1px solid #748292",
                margin: "5px",
                width: "100%",
              }}/>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
              CPR / ID / Social Security Number issued by Govt.
              </label>
              <div className="col-md-9">
                <input
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Date of Birth *
              </label>
              <div className="col-md-9">
                <input type="date" className="form-control shadow-sm" required />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Passport Number
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder=""
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Date of Issue
              </label>
              <div className="col-md-9">
                <input type="date" className="form-control shadow-sm" required />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Expiry Date
              </label>
              <div className="col-md-9">
                <input type="date" className="form-control shadow-sm" required />
              </div>
            </div>


            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Country Issued By</label>
              <div className="col-md-9">
                <input
                  type="email"
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
                </div>
            </div>


            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Resident of Bahrain
              </label>
              <div className="col-md-9">
                <select className="form-select shadow-sm" required>
                  <option value="">Select</option>
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Bahrain Residence Permit Number</label>
              <div className="col-md-9">
                <input
                  type="email"
                  className="form-control shadow-sm"
                  placeholder=""
                  required
                />
                </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Expiry Date
              </label>
              <div className="col-md-9">
                <input type="date" className="form-control shadow-sm" required />
              </div>
            </div>
           
          </div>
        </fieldset>





          {/*Attachments */}
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 2 ? "block" : "none",
            }}>
            <div
              style={{
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
             
            >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Attachments
              </h6>
              <hr
                style={{
                  border: "1px solid #748292",
                  margin: "5px",
                  width: "100%",
                }}
              />

              

              {/* Passport Copy */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Passport Copy (First Page)
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    required
                  />
                </div>
              </div>

              {/* National ID */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Passport Copy (Last Page)
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    required
                  />
                </div>
              </div>

              
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                CPR Front Copy (Optional)
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                CPR Back Copy (Optional)
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                Residence Permit Certificate (Optional)
                </label>
                <div className="col-md-9">
                  <input
                    type="file"
                    className="form-control shadow-sm"
                    accept=".pdf"
                  />
                </div>
              </div>
            </div>
          </fieldset>

      



      {/* Action buttons */}
      <div className="action-button-container" style={{textAlign:"center"}}>
        <button
          type="button"
          className="action-button-previous"
          onClick={handlePrevious}
          style={{ display: currentStep === 0 ? 'none' : 'block' }}
        >
          Previous
        </button>

        {/* Show "Next" or "Submit" based on the current step */}
        {currentStep === steps.length - 1 ? (
          <button
            type="button"
            className="action-button"
            onClick={handleSubmit} // Assuming handleSubmit handles form submission
          >
            Submit
          </button>
        ) : (
          <button
            type="button"
            className="action-button"
            onClick={handleNext}
            style={{ display: currentStep === steps.length - 1 ? 'none' : 'block' }}
          >
            Next
          </button>
        )}
      </div>
      </Container>

    </div>
  );
};

export default StakeHolderDetails;
